// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"63":"931ddeb6","204":"afc99a1c","473":"1ac3f4e7","729":"a73e4de8","814":"afc99a1c","850":"a73e4de8"}[chunkId] + ".chunk.css";
};